import { Warranty } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { CustomTextField, useWarrantyClaimContext } from '@components';
import { Grid, TextFieldProps } from '@mui/material';
import { t } from '@translations';
import { dealerFields } from './warranty.config';

type DealerTextFieldProps = {
  readOnly?: boolean;
  name: keyof Warranty;
  validate?: (value: string) => boolean | string;
} & TextFieldProps;

export const WarrantyDealerFields = () => {
  const { form } = useWarrantyClaimContext();
  const customerNo = form.watch('customerNo');
  return (
    <Grid container spacing={{ xs: 0, sm: 2 }}>
      <Grid item xs={12} lg={6}>
        {customerNo && (
          <CustomTextField
            sx={{ mt: 5 }}
            label={t(TextCodes.Warranty.Block.CustomerNo)}
            InputProps={{
              readOnly: true,
            }}
            value={customerNo}
          />
        )}
        {dealerFields().map((field) => (
          <DealerTextField key={field.name} {...field} />
        ))}
      </Grid>
    </Grid>
  );
};

const DealerTextField = ({
  name,
  label,
  disabled,
  required,
  readOnly,
  validate,
}: DealerTextFieldProps) => {
  const { form, isReadOnly } = useWarrantyClaimContext();
  const error = form.formState.errors[name];

  return (
    <CustomTextField
      {...form.register(name, { required, validate })}
      label={label}
      disabled={disabled}
      sx={{ mt: 5 }}
      error={!!error}
      InputProps={{
        readOnly: isReadOnly || readOnly,
      }}
      required={required && !isReadOnly}
      helperText={typeof error?.message === 'string' ? error.message : ''}
    />
  );
};
